module.exports = __webpack_public_path__ + "img/modal-el-detail.bfbf2048.svg";